import type { FaireProductEntity } from "../../entity_types/product";

export const p_fmqqma79z2: FaireProductEntity = {
  token: "p_fmqqma79z2",
  type: "product",
  name: "Kato Mito Mochi Mystery Bao Gummy Fruity Mix (3oz)",
  brandToken: "b_8688sz59tv",
  brandName: "Showcase",
  imageUrl: "https://cdn.faire.com/fastly/a6ea9c3a6db18d4f6cc4e941d5c89d4b9c7c0a9bc7c5252e4ae79feb1d1d7159.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.99,
  description: "Our hottest candy for Q4 is here. Kato Mito™ Mystery Mochi Bao Gummy is the viral mochi candy shoppers are already looking for, and it moves fast at the register.\n\nEach 3oz bag is packed with soft, squishy, chewy bao shaped gummies in assorted fruity flavors. The catch? You never know which flavor you'll get. That mystery twist is what gets customers grabbing a second bag and coming back for more.\n\nThe bright yellow pouch pops on a shelf, at checkout, or on a peg hook. It's a natural fit for candy and snack sections, stocking stuffers, gift shops, toy stores, and anywhere you sell trending impulse buys.\n\n🍡 Soft, squishy mochi style gummy texture\n🍓 Assorted fruity flavors in every bag\n❓ Mystery flavor surprise kids and adults love\n🔥 Viral candy trend with strong social media buzz\n📦 Sold in cases of 12 x 3oz bags\n🛒 Eye catching packaging built for impulse sales\n🎁 Perfect for Q4 stocking stuffers and holiday gifting\n\nStock up early. This one is selling quickly and Q4 inventory won't last.\n\nShowcase® is an authorized retailer of Kato Mito™\n\n\n\n",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:32.788Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
